import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PlayerButton } from './PlayerButton';
export const FullscreenButton = React.memo(function FullscreenButton({ isFullscreen, onClick }) {
    return (_jsx(PlayerButton, { className: `hekate-player-fullscreen-btn ${isFullscreen ? 'hekate-player-fullscreen-btn--active' : ''}`, tooltip: isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen', onClick: onClick }));
});
